export default function validationExport(response, messages) {
  if (!response || !response.error || !response.error.validationErrors) {
    return;
  }
  response.error.validationErrors.forEach((error) => {
    const message = error.message;

    if (message.indexOf('BILL_EXPORT_ACCOUNTING_WRITING_NULL') === 0) {
      const splitMessage = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFactures.error.exportNoAccountingWriting',
        parametres: {
          code: splitMessage[1],
        },
      });
    }
    if (message.indexOf('BILL_EXPORT_ACCOUNTING_WRITING_INVALID') === 0) {
      const splitMessage = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFactures.error.exportInvalidAccountingWriting',
        parametres: {
          code: splitMessage[1],
        },
      });
    }
  });
}
